






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { get_agency_invoice_detail } from '@/api/invoice';

@Component({
  name: 'InvoiceAgencyDetailDiscrepancies',
})
export default class extends Vue {
  @Prop({ default: true }) flat!: boolean;
  @Prop({ required: true })
  private discrepancies!: get_agency_invoice_detail.Discrepancy;
}
